import { FC, ReactNode } from 'react';

import { StyledFooter } from './Footer.styles';

const Footer: FC<{ children?: ReactNode }> = ({ children, ...props }) => (
	<StyledFooter {...props}>{children}</StyledFooter>
);

export default Footer;
